import { render, staticRenderFns } from "./Bento.vue?vue&type=template&id=0d006329&scoped=true"
import script from "./Bento.vue?vue&type=script&lang=js"
export * from "./Bento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d006329",
  null
  
)

export default component.exports